<wl-homebattery-capacity-advice-ui
  [rendering]="rendering()"
  [energyCapacity]="batteryCapacity()"
/>
